import { render, staticRenderFns } from "./TopicStockPopularTable.vue?vue&type=template&id=0a302038&scoped=true"
import script from "./TopicStockPopularTable.vue?vue&type=script&lang=js"
export * from "./TopicStockPopularTable.vue?vue&type=script&lang=js"
import style0 from "./TopicStockPopularTable.vue?vue&type=style&index=0&id=0a302038&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0a302038",
  null
  
)

export default component.exports